import { slugifyIntroducerName } from "../../../../../domain/introducers/slugifyIntroducerName";

export const slugFollowsName = (
    originalSlug: string | null,
    editedSlug: string | null,
    editedName: string | null,
): boolean => {
    if (originalSlug) {
        return false;
    }
    if (!editedSlug) {
        return true;
    }
    return editedSlug === slugifyIntroducerName(editedName || "");
};
